export class MenuToggleClass {
    private readonly classTrigger = "js-menu-toggle";
    private readonly classActive = 'is-menu-mobile-active';

    private body: HTMLElement;
    private toggleBtns: HTMLButtonElement[];

    constructor() {
        this.init();
    }

    init(): void {

        this.body = document.body;
        this.toggleBtns = Array.from(document.querySelectorAll('.' + this.classTrigger));

        if (this.toggleBtns.length === 0) {
            return;
        }

        this.toggleBtns.forEach(toggleBtn => {
            toggleBtn.addEventListener('click', (e) => this.onClickToggle(e));
        });
    }

    /**
     * Click toggle menu
     * @param e
     */
    onClickToggle(e: Event) {
        const link: string = (e.currentTarget as any)?.href;
        e.preventDefault();
        this.body.classList.toggle(this.classActive);

        if (link) {
            const anchor = link.substring(link.lastIndexOf('#'));
            document.querySelector(anchor).scrollIntoView({ behavior: 'smooth' });
        }
    }


}
